import useDevice from "@/hooks/useDevice";
import { FC, useMemo, CSSProperties, PropsWithChildren } from "react";
import TheFooter from "@/components/TheFooter";
import RecommendBoards from "@/features/board/components/RecommendBoards";
import { useHeaderHeight } from "@/hooks/useHeaderHeight";

interface Props {
  sidebar?: JSX.Element;
  conditions: JSX.Element;
  modal: JSX.Element;
  dropdowns: JSX.Element;
  modalOpen: boolean;
  hasCondition: boolean;
  headerView?: JSX.Element;
  hiddenBoards?: boolean;
}

const SiderBarWidth = 248;

const SearchGroup: FC<PropsWithChildren<Props>> = ({
  children,
  sidebar,
  headerView,
  conditions,
  modal,
  modalOpen,
  hasCondition,
  dropdowns,
  hiddenBoards = false,
}): JSX.Element => {
  const { isSp } = useDevice();
  const headerHeight = useHeaderHeight();

  const mainStyle = useMemo<CSSProperties>(() => {
    if (isSp) return {};

    return {
      paddingLeft: sidebar ? SiderBarWidth : 0,
    };
  }, [sidebar, isSp, SiderBarWidth]);

  return (
    <div className="laptop:p-0">
      {sidebar && (
        <div
          className="hidden laptop:block laptop:fixed laptop:left-0 laptop:bottom-0 border-primary border-r hidden-scrollbar"
          style={{
            overflow: "auto",
            top: headerHeight,
            padding: "48px 24px",
            width: SiderBarWidth,
          }}
        >
          {sidebar}
        </div>
      )}

      <main className="pl-0" style={{ ...mainStyle }}>
        <div className="space-y-40">
          {headerView && <div className="laptop:mb-40">{headerView}</div>}
          <div className={[!headerView ? "laptop:pt-48 pt-32" : ""].join(" ")}>
            <header className="space-y-80 laptop:px-32 px-8">
              {!hiddenBoards && <RecommendBoards />}
              <div className="space-y-24">
                <div className="space-y-16 laptop:space-y-24">
                  {hasCondition && <>{conditions}</>}
                </div>
                {isSp && sidebar && dropdowns}
              </div>
            </header>
          </div>
          <div className="laptop:px-32 px-8 min-h-screen">{children}</div>
          <TheFooter />
        </div>

        {modalOpen && <>{modal}</>}
      </main>
    </div>
  );
};

export default SearchGroup;
